export default function formatMessageContentEventWithdraw (text) {
    return {
        text
    }
}
